import React, { useEffect, useRef } from 'react';
import './FloatingBlobs.css';

const FloatingBlobs = () => {
  const blob1Ref = useRef(null);
  const blob2Ref = useRef(null);
  const blob3Ref = useRef(null);

  useEffect(() => {
    const handleMouseMove = (e) => {
      const x = (e.clientX / window.innerWidth - 0.5) * 2;
      const y = (e.clientY / window.innerHeight - 0.5) * 2;

      if (blob1Ref.current) {
        const speed = 1 * 20;
        blob1Ref.current.style.transform = `translate(${x * speed}px, ${y * speed}px)`;
      }
      if (blob2Ref.current) {
        const speed = 2 * 20;
        blob2Ref.current.style.transform = `translate(${x * speed}px, ${y * speed}px)`;
      }
      if (blob3Ref.current) {
        const speed = 3 * 20;
        blob3Ref.current.style.transform = `translate(${x * speed}px, ${y * speed}px)`;
      }
    };

    document.addEventListener('mousemove', handleMouseMove);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return (
    <>
      <div ref={blob1Ref} className="blob blob1"></div>
      <div ref={blob2Ref} className="blob blob2"></div>
      <div ref={blob3Ref} className="blob blob3"></div>
    </>
  );
};

export default FloatingBlobs;
